<template>
  <div class="flex flex-column gap-2">
    <div class="flex p-float-label">
      <Calendar
        v-model="v$.value.$model"
        v-bind="$attrs"
        dateFormat="dd/mm/yy"
        showIcon
        inputId="date_range"
        class="flex-grow-1"
        selectionMode="multiple"
        :manualInput="false"
      />
      <label for="">{{ props.label }}</label>
    </div>
    <div class="flex">
      <small v-if="v$.value.$error" id="date_range-help" class="p-error">Date is required</small>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
const props = defineProps({
  modelValue: Array,
  label: {
    type: String,
    required: true
  },
  required: Boolean
})
let value = undefined
if (props.modelValue == undefined) {
  value = ref()
} else {
  value = ref()
}

const rules = computed(() => {
  const v = {}
  if (props.required) {
    v.value = { required }
  } else {
    v.value = {}
  }
  return v
})

const v$ = useVuelidate(rules, { value })
</script>
